import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rValue } from '../../models/.catalog';
import rOyakProjeToplamHakedis from '../../models/rOyakProjeToplamHakedis';

export default class OyakProjeToplamHakedisApi extends ApiBase<
  pList,
  rValue<rOyakProjeToplamHakedis>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/HakedisBilgileri',
      }),
      options
    );
  }
}
